import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["aria-expanded"]
const _hoisted_10 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }

import {reactive} from "vue";
import ItemV3StonesStoneSize from "@/components/itemV3/parameter/stones/parameter/itemV3StonesStoneSize.vue";
import ItemV3StonesQuality from "@/components/itemV3/parameter/stones/parameter/itemV3StonesQuality.vue";
import ItemV3StonesPresets from "@/components/itemV3/parameter/stones/parameter/itemV3StonesPresets.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesGroupStarrySky',
  props: {
    groupIdx: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

/**
 * headlines - collapsible sections (transferred from itemV3Grooves.vue's
 * "groove details - collapsible sections")
 */

const openSections = reactive<Record<string, boolean>>({
  presets: true,
  quality: false,
  stone_size: false,
})

const toggleSection = (key: string) => {
  openSections[key] = !openSections[key]
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.presets,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSection('presets')))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_4, [
          _cache[7] || (_cache[7] = _createTextVNode(" Bibliothek ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.presets ? 'rotate-180' : ''])
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_3),
      (openSections.presets)
        ? (_openBlock(), _createBlock(ItemV3StonesPresets, {
            key: 0,
            class: "w-full",
            show: true,
            "stone-layout": "starry_sky",
            "stone-tag": "",
            onPatch: _cache[1] || (_cache[1] = (event) => emit('patch', event))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.quality,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSection('quality')))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_7, [
          _cache[11] || (_cache[11] = _createTextVNode(" Steinart/Qualität ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.quality ? 'rotate-180' : ''])
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_6),
      (openSections.quality)
        ? (_openBlock(), _createBlock(ItemV3StonesQuality, {
            key: 0,
            class: "w-full",
            "group-idx": props.groupIdx,
            onPatch: _cache[3] || (_cache[3] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.stone_size,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSection('stone_size')))
      }, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_10, [
          _cache[15] || (_cache[15] = _createTextVNode(" Steingröße ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.stone_size ? 'rotate-180' : ''])
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_9),
      (openSections.stone_size)
        ? (_openBlock(), _createBlock(ItemV3StonesStoneSize, {
            key: 0,
            class: "w-full",
            "group-idx": props.groupIdx,
            onPatch: _cache[5] || (_cache[5] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})